import React, { useState } from 'react';
import {
    Box,
    Checkbox,
    ListItemText,
    MenuItem, Modal,
    OutlinedInput,
    Select,
} from "@mui/material";
import {useDispatch} from "react-redux";
import {mainApi} from "../../store/services/mainApi";
import { ReactComponent as EditIcon } from '../../assets/svg/BuyerOperacion/edit.svg'
import { ReactComponent as MBIcon } from '../../assets/svg/ShoppingOperation/MBIcon.svg'
import { ReactComponent as BcnIcon } from '../../assets/svg/ShoppingOperation/BcnIcon.svg'
import { ReactComponent as CargIcon } from '../../assets/svg/ShoppingOperation/CarIcon.svg'
import { ReactComponent as CompIcon } from '../../assets/svg/ShoppingOperation/Euro.svg'
import { ReactComponent as ReservIcon } from '../../assets/svg/ShoppingOperation/GreenCalendar.svg'
import { ReactComponent as NoHayIcon } from '../../assets/svg/ShoppingOperation/RedCalendar.svg'
import { ReactComponent as DesCarIcon } from '../../assets/svg/ShoppingOperation/DesCargIcon.svg'
import { ReactComponent as ColumnSettingsIcon } from '../../assets/svg/ShoppingOperation/ColumnSettings.svg'


const ItemsProductionFilters = ({editChange, setEditChange, setButtonFilters, buttonFilters, isLoading, checkBoxStyle, deliveryDateModal, setDeliveryDateModal, handleStatusChange, handleTradeNameChange, handleLocChange, handleProveedorChange, mobileScreen, selectedDeliveryDates, selectedTradeNames, selectedProveedors, optionsAutoComplete, uniqueProveedors, statuses, switchClientZumos, activeLocationMode, setActiveLocationMode, setSwitchClientZumos, setSearch, userColumnsFields, columnsFildsAccordion, setUserColumnsFields, setUserColumnsFieldsList, userColumnsFieldsList, columnsFildsList, userColumnsFieldsClient, setUserColumnsFieldsClient, columnsFildsClient, setActiveStatusMode, activeStatusMode, locations=[], setSelectedLoc, selectedLoc, handlePavilionChange, activePavilionMode, setActivePavilionMode}) => {
  const dispatch = useDispatch()

  // console.log(optionsAutoComplete);
  // console.log(uniqueProveedors);

  const getUnique = (arr, field) => {
    if (!Array.isArray(arr)) {
      return [];
    }
    const uniqueParts = new Set();
    arr.forEach((obj) => {
      const placeValue = obj[field]
      // Пропускаем null, undefined и нестроковые значения
      if (placeValue == null || typeof placeValue !== 'string') {
        return;
      }
      // Разделяем значение place по '/'
      const parts = placeValue.split('/');
      // Обрабатываем каждую часть
      parts.forEach((part) => {
        const trimmedPart = part.trim();
        if (trimmedPart) {
          uniqueParts.add(trimmedPart);
        }
      });
    });
    return Array.from(uniqueParts);
  };

  const GroupingMode = [
    { value: 1, name: 'Products' },
    { value: 2, name: 'List' },
    { value: 3, name: 'Client' }
  ]
  const TimeMode = [
    { value: 'All', name: 'All' },
    { value: 'PLM', name: 'PLM☀️' },
    { value: 'PLT', name: 'PLT🌙' },
  ]
  
  
  const locationMode = [
    { value: 'All', name: 'All' },
    { value: 'MB', name: 'MB' },
    { value: 'BCN', name: 'BCN' },
  ]
  function renderCityIcon(icon) {
    switch (icon) {
      case 'All':
        return 'All';
      case 'MB':
        return <MBIcon height={25}/>;
      case 'BCN':
        return <BcnIcon height={25}/>
      case 'Cargado':
        return <CargIcon height={22}/>
      case 'Comparar':
        return <CompIcon height={24}/>
      case 'Reservado':
        return <ReservIcon height={26}/>
      case 'NoHay':
        return <NoHayIcon height={26}/>
      case 'DesCar':
        return <DesCarIcon height={26}/>
      default:
        return '';
    }
  }

  const pavilionMode = [
    {value: 'All', name: 'All', color: '#252525'},
    {value: '1', name: '1A', color: '#5FC56E'},
    {value: '2', name: '2B', color: '#ff2000'},
    {value: '3', name: '3C', color: '#FF8C04'},
    {value: '4', name: '4D', color: '#0351ff'},
    {value: '5', name: '5E', color: '#b403ff'},
    {value: '6', name: '6F', color: '#a41010'},
    {value: '7', name: '7G', color: '#06c0b0'},
    {value: '0', name: 'PVL', color: '#DCD024'},
    {value: 'M', name: 'MB', color: '#A5A38C'},
  ]

  
  const statusMode = [
    { value: 'All', name: 'All' },
    { value: 'Cargado', name: 'Cargado' },
    { value: 'Comprar', name: 'Comparar' },
    { value: 'Reservado', name: 'Reservado' },
    { value: 'No Hay', name: 'NoHay' },
    { value: 'Descargado', name: 'DesCar' },
  ]

  const [openColumnsSettings, setOpenColumnsSettings] = useState(false)
  // console.log(locations);

  return (
    <Box className='ItemsProduction'>
      <Box className='ItemsProduction__row'>
        <Box className='ItemsProduction__filter'>
          <h3>Grouping</h3>
          <Box className='ItemsProduction__filter__grouping'>
            {GroupingMode.map((item) => (
              <Box 
                className='ItemsProduction__filter__grouping__item'
                key={item.value}
                sx={{
                  backgroundColor: switchClientZumos === item.value ? '#e1ebe1' : 'transparent',
                }}
                onClick={() => {setSwitchClientZumos(item.value);  dispatch(mainApi.util.invalidateTags(['itemsOperacion']))}}
              >
                {item.name}
              </Box>
            ))}
          </Box>
        </Box>
        <Box className='ItemsProduction__filter'>
          <h3>Client</h3>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            color="success"
            multiple
            value={selectedTradeNames}
            onChange={handleTradeNameChange}
            input={<OutlinedInput sx={{ 
              '& .MuiOutlinedInput-input': {
                padding: '6px 14px',
              }
            }} />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: '200px',
                  marginTop: '5px',
                  borderRadius: '7px',
                  border: '1px solid #d9d9d9'
                },
              },
            }}
            sx={{
              width: 170,
              height: 30,
              borderRadius: '7px',
              border: '1px solid #d9d9d9',
              '& .MuiSelect-select': {
                fontSize: '14px',
                fontWeight: 500,
                color: '#4c4c4c',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              '&:hover': {
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                }
              },
              '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                  boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                }
              }
            }}
          >
            {optionsAutoComplete?.sort((a, b) => a.label.localeCompare(b.label))?.map((el) => (
              <MenuItem key={el.label} value={el.label} sx={{ py: 0 }}>
                <Checkbox 
                  sx={{ 
                    padding: '3px',
                    color: '#d9d9d9',
                    '&.Mui-checked': {
                      color: '#1890ff',
                    }
                  }}
                  checked={selectedTradeNames.includes(el.label)}/>
                <ListItemText primary={el.label} 
                  sx={{ 
                    '& .MuiTypography-root': {
                      fontSize: '14px',
                      color: '#4c4c4c',
                    }
                  }}
                />
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box className='ItemsProduction__filter'>
          <h3>City</h3>
          <Box className='ItemsProduction__filter__grouping'>
            {locationMode.map((item) => (
            <Box 
              className='ItemsProduction__filter__grouping__item'
              key={item.value}
              sx={{
                backgroundColor: activeLocationMode === item.value ? '#e1ebe1' : 'transparent',
                width: '35px',
                boxSizing: 'border-box',
                padding: 0
              }}
              onClick={() => {setActiveLocationMode(item.value);  dispatch(mainApi.util.invalidateTags(['itemsOperacion']))}}
            >
              {renderCityIcon(item.name)}
            </Box>
            ))}
          </Box>
        </Box>
        <Box className='ItemsProduction__filter'>
          <h3>Product status</h3>
          <Box className='ItemsProduction__filter__grouping'>
            {statusMode.map((item) => (
            <Box 
              className='ItemsProduction__filter__grouping__item'
              key={item.value}
              sx={{
                backgroundColor: activeStatusMode === item.value ? '#e1ebe1' : 'transparent',
                width: '35px',
                boxSizing: 'border-box',
                padding: 0
              }}
              onClick={() => {setActiveStatusMode(item.value);  dispatch(mainApi.util.invalidateTags(['itemsOperacion']))}}
            >
              {renderCityIcon(item.name)}
            </Box>
            ))}
          </Box>
        </Box>
        
      </Box>
      <Box className='ItemsProduction__row'>
        <Box className='ItemsProduction__filter'>
          <h3 style={{ color: 'transparent'}}>Col</h3>
          <Box className='ItemsProduction__filter__grouping'
            sx={{
              width: '30px',
              justifyContent: 'center',
              border: !openColumnsSettings ? '1px solid #d9d9d9' : '1px solid #2E732F',
              transition: 'border 0.3s ease-in-out',
              cursor: 'pointer',
              position: 'relative'
            }}
            onClick={() => {
              setOpenColumnsSettings(prew => !prew)
            }}
          >
            <ColumnSettingsIcon  width={20} height={20}/>
          </Box>
          {openColumnsSettings && <Box 
            sx={{ height: '100%', width: '100%', position: 'absolute', top: '0', left: '0', zIndex: '4', }}
            onClick={() => {
              setOpenColumnsSettings(false)
            }}  
          ></Box>}
          {openColumnsSettings && <Box className='ItemsProduction__filter__modal'
            sx={{
              position: 'absolute',
              backgroundColor: 'white',
              padding: '5px',
              transform: 'translate(40px, 20px)',
              borderRadius: '10px',
              display: 'flex',
              flexDirection: 'column',
              width: '150px',
              height: '300px',
              outline: 'none',
              zIndex: '5',
              filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
              overflowY: 'scroll',
              fontSize: '12px',
              fontWeight: '500',
              color: '#2a2d2f',
              boxSizing: 'border-box'
            }}
          > 
            {switchClientZumos === 1 && (columnsFildsAccordion.map((item) => (
              <Box key={item} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                <Checkbox
                  checked={userColumnsFields?.includes(item)}
                  onClick={(e) => {
                    if (e.target.checked) {
                      setUserColumnsFields([...userColumnsFields, item]);
                      localStorage.setItem('userColumnsFildsShopping', JSON.stringify([...userColumnsFields, item]));
                    } else {
                      setUserColumnsFields([...userColumnsFields.filter((col) => col !== item)]);
                      localStorage.setItem('userColumnsFildsShopping', JSON.stringify([...userColumnsFields.filter((col) => col !== item)]));
                    }
                  }}
                />
                <span>{item}</span>
              </Box>
            )))}
            {switchClientZumos === 2 && (columnsFildsList.map((item) => (
              <Box key={item} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                <Checkbox
                  checked={userColumnsFieldsList?.includes(item)}
                  onClick={(e) => {
                    if (e.target.checked) {
                      setUserColumnsFieldsList([...userColumnsFieldsList, item]);
                      localStorage.setItem('userColumnsFildsShoppingList', JSON.stringify([...userColumnsFieldsList, item]));
                    } else {
                      setUserColumnsFieldsList([...userColumnsFieldsList.filter((col) => col !== item)]);
                      localStorage.setItem('userColumnsFildsShoppingList', JSON.stringify([...userColumnsFieldsList.filter((col) => col !== item)]));
                    }
                  }}
                />
                <span>{item}</span>
              </Box>
            )))}
            {switchClientZumos === 3 && (columnsFildsClient.map((item) => (
              <Box key={item} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                <Checkbox
                  checked={userColumnsFieldsClient?.includes(item)}
                  onClick={(e) => {
                    if (e.target.checked) {
                      setUserColumnsFieldsClient([...userColumnsFieldsClient, item]);
                      localStorage.setItem('userColumnsFildsShoppingClient', JSON.stringify([...userColumnsFieldsClient, item]));
                    } else {
                      setUserColumnsFieldsClient([...userColumnsFieldsClient.filter((col) => col !== item)]);
                      localStorage.setItem('userColumnsFildsShoppingClient', JSON.stringify([...userColumnsFieldsClient.filter((col) => col !== item)]));
                    }
                  }}
                />
                <span>{item}</span>
              </Box>
            )))}
          </Box>}
        </Box>
        <Box className='ItemsProduction__filter'>
          <h3>Time</h3>
          <Box className='ItemsProduction__filter__grouping'>
            {TimeMode.map((item) => (
              <Box 
                className='ItemsProduction__filter__grouping__item'
                key={item.value}
                sx={{
                  backgroundColor: (Object.keys(buttonFilters).find((key) =>
                    ["PLM", "PLT"].includes(key) && buttonFilters[key]
                  ) || "All") == item.value ? '#e1ebe1' : 'transparent',
                }}
                onClick={() => {
                  const selectedValue = item.value;

                  setButtonFilters((prevState) => {
                    // Если выбран "All", сбрасываем только PLM/PLT-фильтры
                    if (selectedValue === "All") {return {...prevState, PLM: false, PLT: false,}}
                    // Устанавливаем выбранный PLM/PLT-фильтр в true, остальные сбрасываем
                    return {...prevState, PLM: selectedValue === "PLM", PLT: selectedValue === "PLT",};
                  });
                }}
              >
                {item.name}
              </Box>
            ))}
          </Box>
        </Box>
        <Box className='ItemsProduction__filter'>
          <h3>Proveedor</h3>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            color="success"
            multiple
            value={selectedProveedors}
            onChange={handleProveedorChange}
            input={<OutlinedInput sx={{ 
              '& .MuiOutlinedInput-input': {
                padding: '6px 14px',
              }
            }} />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: '200px',
                  marginTop: '5px',
                  borderRadius: '7px',
                  border: '1px solid #d9d9d9'
                },
              },
            }}
            sx={{
              width: 170,
              height: 30,
              borderRadius: '7px',
              border: '1px solid #d9d9d9',
              '& .MuiSelect-select': {
                fontSize: '14px',
                fontWeight: 500,
                color: '#4c4c4c',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              '&:hover': {
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                }
              },
              '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                  boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                }
              }
            }}
          >
            {uniqueProveedors?.sort((a, b) => a.label.localeCompare(b.label))?.map((el) => (
              <MenuItem key={el.label} value={el.label} sx={{ py: 0 }}>
                <Checkbox 
                  sx={{ 
                    padding: '3px',
                    color: '#d9d9d9',
                    '&.Mui-checked': {
                      color: '#1890ff',
                    }
                  }}
                  checked={selectedProveedors.includes(el.label)}/>
                <ListItemText primary={el.label} 
                  sx={{ 
                    '& .MuiTypography-root': {
                      fontSize: '14px',
                      color: '#4c4c4c',
                    }
                  }}
                />
              </MenuItem>
            ))}
          </Select>
        </Box>
        {activeLocationMode !== 'MB' && <Box className='ItemsProduction__filter'>
          <h3>Location</h3>
          <Box className='ItemsProduction__filter__location'>
            <Box className='ItemsProduction__filter__location__all' onClick={() => setSelectedLoc([])}>
              All
            </Box>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              color="success"
              multiple
              value={selectedLoc}
              onChange={handleLocChange}
              input={<OutlinedInput sx={{ 
                '& .MuiOutlinedInput-input': {
                  padding: '6px 14px',
                }
              }} />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: '200px',
                    marginTop: '5px',
                    borderRadius: '7px',
                    border: '1px solid #d9d9d9'
                  },
                },
              }}
              sx={{
                width: 70,
                height: 30,
                outline: 'none',
                '& .MuiSelect-select': {
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#4c4c4c',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  }
                },
                '&.Mui-focused': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                    boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
                  }
                }
              }}
            >
              {locations.map((el) => (
                <MenuItem key={el.label} value={el.label} sx={{ py: 0 }}>
                  <Checkbox 
                    sx={{ 
                      padding: '3px',
                      color: '#d9d9d9',
                      '&.Mui-checked': {
                        color: '#1890ff',
                      }
                    }}
                    checked={selectedLoc.includes(el.label)}/>
                  <ListItemText primary={el.label} 
                    sx={{ 
                      '& .MuiTypography-root': {
                        fontSize: '14px',
                        color: '#4c4c4c',
                      }
                    }}
                  />
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>}
        {activeLocationMode !== 'BCN' && <Box className='ItemsProduction__filter'>
          <h3>Pavilions</h3>
          <Box className='ItemsProduction__filter__grouping'>
            {pavilionMode.map((item) => (
              <Box 
                className='ItemsProduction__filter__grouping__item'
                key={item.value}
                sx={{
                  backgroundColor: activePavilionMode === item.value ? '#e1ebe1' : 'transparent',
                  color: item.color
                }}
                onClick={() => {setActivePavilionMode(item.value);  dispatch(mainApi.util.invalidateTags(['itemsOperacion']))}}
              >
                {item.name}
              </Box>
            ))}
          </Box>
        </Box>}
        
        <Box className='ItemsProduction__filter' sx={{ marginLeft: 'auto'}}>
          <h3 style={{ color: 'transparent'}}>Search</h3>
          <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center'}}>
            <button
              className='ItemsProductionBtn'
            
            >
              Add
            </button>
            <Box className='AddToStockModal__body__filters__search' sx={{ height: '30px', width: '200px'}}>
              <input 
                onChange={(e) => setSearch(e.target.value)}
                placeholder='Search...'
              />
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.69237 16.4164C3.69237 16.4004 3.68806 16.3858 3.68114 16.3739L3.65482 16.4001L3.61475 16.4324L1.07591 18.4818L1.07589 18.4818C1.06157 18.4933 1.04699 18.5045 1.03215 18.5152C0.973162 18.6425 0.995386 18.8007 1.09851 18.9049C1.21903 19.0267 1.40736 19.0315 1.53323 18.9193L3.6258 16.521L3.62577 16.521L3.63091 16.5152L3.68165 16.458C3.6883 16.4461 3.69237 16.4318 3.69237 16.4164ZM11.4224 1C9.41612 1 7.48986 1.80545 6.06793 3.24268C4.64565 4.68026 3.84472 6.6323 3.84472 8.66993C3.84472 12.916 7.24741 16.3399 11.4224 16.3399C15.5973 16.3399 19 12.916 19 8.66993C19 4.42383 15.5973 1 11.4224 1Z" stroke="#7E7E7E" strokeWidth="2" />
              </svg>
            </Box>
          </Box>
        </Box>
        

      </Box>
    </Box>
  );
};

export default ItemsProductionFilters;